import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MonthlyDetail } from '../../../../types/financial-flow';
import { formatCurrency } from '../../../../utils/currency';
import { formatDate } from '../../../../utils/date';

export default function useTableColumns() {
  const { t } = useTranslation();

  const columns: ColumnTable<MonthlyDetail>[] = useMemo(() => {
    const tariffFormatter = formatCurrency({ symbol: false });
    return [
      {
        columnName: 'date',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.date`),
        cellFormat: ({ row }) => {
          return formatDate(row.date, 'DD/MM/YYYY');
        },
      },
      {
        columnName: 'projectName',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.accountTitle`),
      },
      {
        columnName: 'entry',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.voucherNumber`),
      },
      {
        columnName: 'description',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.explanation`),
        cellFormat: ({ row }) => {
          return row.description || '-';
        },
      },
      {
        columnName: 'income',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.income`),
        cellFormat: ({ row }) => {
          return tariffFormatter.format(Number(row.debit));
        },
      },
      {
        columnName: 'outflow',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`common.terms.outflow`),
        cellFormat: ({ row }) => {
          return tariffFormatter.format(Number(row.credit));
        },
      },
    ];
  }, [t]);

  return columns;
}
